import { PopupReturnTypeWithPayload } from '../../../hooks/usePopup'
import { initialPopup } from '../../../hooks/constants'
import { TRebatesTableType } from '../Rebates/RebatesTable/types'
import { TRebatePaymentData } from '../PaymentActions/RebatesPaymentPopups/types'
import { TCompleteRebatesPaymentData } from '../PaymentActions/CompleteRebatesPopup/types'
import { CognusARData } from '../CognusAR/CognusARTable/types'
import { MarketplaceARRebateCorrelationCheckResponseData } from '../CognusAR/types'

export type RebatesPaymentPopupPayload = {
  row: TRebatesTableType
}

export type InitiateRebatesPaymentPopupPayload = RebatesPaymentPopupPayload & {
  rebatePaymentData: TRebatePaymentData
}

export type CompleteRebatesPaymentPopupPayload = RebatesPaymentPopupPayload & {
  completeRebatesPaymentData: TCompleteRebatesPaymentData
}

export const rebatesPaymentPopupWithPayload: PopupReturnTypeWithPayload<RebatesPaymentPopupPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: {
        row: {} as TRebatesTableType
      }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }

export const initiateRebatesPaymentPopupWithPayload: PopupReturnTypeWithPayload<InitiateRebatesPaymentPopupPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: {
        row: {} as TRebatesTableType,
        rebatePaymentData: {} as TRebatePaymentData
      }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }

export const completeRebatesPaymentPopupWithPayload: PopupReturnTypeWithPayload<CompleteRebatesPaymentPopupPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: {
        row: {} as TRebatesTableType,
        completeRebatesPaymentData: {} as TCompleteRebatesPaymentData
      }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }

export type InvoicesDetailsPopupPayload = {
  invoiceData: CognusARData
}

export const invoicesDetailsPopupWithPayload: PopupReturnTypeWithPayload<InvoicesDetailsPopupPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: {
        invoiceData: {} as CognusARData
      }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }

export type DisputeProcessCantBeDonePopupPayload = {
  correlationCheck: MarketplaceARRebateCorrelationCheckResponseData
}

export const disputeProcessCantBeDonePopupWithPayload: PopupReturnTypeWithPayload<DisputeProcessCantBeDonePopupPayload> =
  {
    state: {
      ...initialPopup?.state,
      payload: {
        correlationCheck: {
          is_successful: false,
          paid_rebate_quarters: [],
          not_paid_rebate_quarters: []
        }
      }
    },
    actions: {
      ...initialPopup.actions,
      setState: () => undefined
    }
  }
